export enum HttpEndpoints {
  LP_CONFIG = '/data/config/lp-config.json',
  // LP_STATIC_TEXTS = '/data/lp-static-texts.json',
}
